import { Container, Card, CardGroup, Form, Row, Col } from "react-bootstrap";
import {
  faPencil,
  faMagnifyingGlass,
  faPaperclip,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import ModalButton from "./ModalButton";
function CommonApp() {
  return (
    <div>
      <Container style={{ marginBottom: "3%", marginTop: "5%" }}>
        <h1>Financing, streamlined.</h1>
        <p>
          Say goodbye to the days of hiring brokers to source buyers, preparing
          multiple applications for financing, and educating your investors. We
          help you get the best terms and put you in front of the right buyers.
        </p>
        <div>
          <CardGroup>
            <Card
              style={{
                borderRadius: "10px",
                margin: "10px",
                border: "0px",
                boxShadow: "0 4px 8px 0 rgba(0, 0, 0, 0.2)",
              }}
            >
              {" "}
              <Card.Body>
                <Card.Title>
                  {" "}
                  <FontAwesomeIcon icon={faPencil}></FontAwesomeIcon>
                  Application
                </Card.Title>
                <Card.Text>
                  We'll take in general information about your project, the
                  amount requested, site address, energy costs, ownership, etc.
                </Card.Text>
              </Card.Body>
            </Card>
            <Card
              style={{
                borderRadius: "10px",
                margin: "10px",
                border: "0px",
                boxShadow: "0 4px 8px 0 rgba(0, 0, 0, 0.2)",
              }}
            >
              {" "}
              <Card.Body>
                <Card.Title>
                  <FontAwesomeIcon icon={faMagnifyingGlass}></FontAwesomeIcon>{" "}
                  Diligence
                </Card.Title>
                <Card.Text>
                  We'll look at your project's financial history, formation
                  documents, operating agreement, and proof of ownership
                </Card.Text>
              </Card.Body>
            </Card>
            <Card
              style={{
                borderRadius: "10px",
                margin: "10px",
                border: "0px",
                boxShadow: "0 4px 8px 0 rgba(0, 0, 0, 0.2)",
              }}
            >
              {" "}
              <Card.Body>
                <Card.Title>
                  {" "}
                  <FontAwesomeIcon icon={faPaperclip}></FontAwesomeIcon>{" "}
                  Contract Terms
                </Card.Title>
                <Card.Text>
                  Thank you for submitting the financing application. Once your
                  application is reviewed, we'll put you in front of high
                  quality buyers and help you finalize the contract and terms.
                </Card.Text>
              </Card.Body>
            </Card>
          </CardGroup>
          <br></br>
        </div>
        <div className="underline"></div>
      </Container>

      <Container style={{ marginBottom: "10%" }}>
        {" "}
        <Form>
          <Form.Group className="mb-3" controlId="formBasicEmail">
            <Form.Label>Developer Name</Form.Label>
            <Form.Control type="text" placeholder="Name" />
          </Form.Group>
          <Form.Group className="mb-3" controlId="formBasicEmail">
            <Form.Label>Website</Form.Label>
            <Form.Control type="text" placeholder="Website" />
          </Form.Group>

          <Form.Group className="mb-3" controlId="formGridAddress1">
            <Form.Label>Site Address 1</Form.Label>
            <Form.Control placeholder="1234 Main St" />
          </Form.Group>

          <Form.Group className="mb-3" controlId="formGridAddress2">
            <Form.Label>Site Address 2</Form.Label>
            <Form.Control placeholder="Apartment, studio, or floor" />
          </Form.Group>

          <Row className="mb-3">
            <Form.Group as={Col} controlId="formGridCity">
              <Form.Label>City</Form.Label>
              <Form.Control type="text" placeholder="New York" />
            </Form.Group>

            <Form.Group as={Col} controlId="formGridState">
              <Form.Label>State</Form.Label>
              <Form.Select defaultValue="Choose...">
                <option>Choose...</option>
                <option>...</option>
              </Form.Select>
            </Form.Group>

            <Form.Group as={Col} controlId="formGridZip">
              <Form.Label>Zip</Form.Label>
              <Form.Control type="text" placeholder="10027" />
            </Form.Group>
          </Row>

          <Form.Group className="mb-3">
            <Form.Label>Size & Production</Form.Label>
            <Form.Control type="text" placeholder="5MW" />
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>Electric Utility</Form.Label>
            <Form.Control type="text" placeholder="ConEdison" />
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>Monthly Energy Costs</Form.Label>
            <Form.Control type="text" placeholder="$500" />
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>Program Type</Form.Label>
            <Form.Control type="text" placeholder="Commercial" />
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>Rebates & Incentives</Form.Label>
            <Form.Control
              type="text"
              placeholder="Investment Tax Credit, Domestic Content Adder,..."
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Primary Inverter Manufacturer</Form.Label>
            <Form.Control type="text" placeholder="Enphase, Tesla,..." />
          </Form.Group>
          <Form.Group as={Col} controlId="formGridState">
            <Form.Label>Project Status</Form.Label>
            <Form.Select defaultValue="Choose...">
              <option>Choose...</option>
              <option>Pipeline</option>
              <option>Complete</option>
            </Form.Select>
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>Project Cost</Form.Label>
            <Form.Control type="text" placeholder="$500,000" />
          </Form.Group>
          <Form.Group>
            <Form.Label>Financial History</Form.Label>
            <Form.Control type="file" />
          </Form.Group>
          <br></br>

          <ModalButton></ModalButton>
        </Form>
      </Container>
    </div>
  );
}

export default CommonApp;
